<template>
  <div
    ref="card"
    :style="{ '--content-min-height': contentMinHeight }"
    style="
      border-radius: 5px;
      margin: 10px 50px;
      padding: 30px;
      background-color: #fff;
      box-shadow: 0 0 10px rgba(200, 200, 200, 0.5);
      min-height: var(--content-min-height, 100vh);
    "
  >
    <el-button
      v-if="!hideBack"
      @click="routeBack"
      type="success"
      style="display: inline-block; float: right"
      >Назад</el-button
    >
    <keep-alive
      include="@/components/ecologist/dataEntry/dataEntryMain,dataEntryMainView"
    >
      <slot></slot>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "containerComponent",
  data() {
    return {
      contentMinHeight: null,
      resizeObserver: null,
    };
  },
  computed: {
    // Флаг у родительского маршрута: в vue-router 3 $route.meta - только у вложенного
    hideBack() {
      return this.$route.matched.some((record) => record.meta.hideBack);
    },
  },
  methods: {
    routeBack() {
      this.$router.go(-1);
    },

    updateContentMinHeight() {
      const card = this.$refs.card;
      const style = getComputedStyle(card);
      const top = card.getBoundingClientRect().top + window.scrollY;
      const height =
        window.innerHeight -
        top -
        parseFloat(style.marginBottom) -
        parseFloat(style.paddingTop) -
        parseFloat(style.paddingBottom);
      this.contentMinHeight = height + "px";
    },
  },
  mounted() {
    this.updateContentMinHeight();
    window.addEventListener("resize", this.updateContentMinHeight);
    this.resizeObserver = new ResizeObserver(this.updateContentMinHeight);
    this.resizeObserver.observe(document.body);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateContentMinHeight);
    this.resizeObserver.disconnect();
  },
};
</script>

<style scoped></style>
